export type ReconciliationRunStatusVariant = 'success' | 'warn' | 'danger' | 'neutral' | 'pending';

export const runStatusVariant = (status: string): ReconciliationRunStatusVariant => {
  switch (status) {
    case 'COMPLETE':
      return 'success';
    case 'PARTIAL':
      return 'warn';
    case 'FAILED':
      return 'danger';
    case 'QUEUED':
    case 'RUNNING':
      return 'pending';
    default:
      return 'neutral';
  }
};

export const RUN_STATUS_BADGE_CLASS: Record<ReconciliationRunStatusVariant, string> = {
  success: 'bg-success text-success-foreground',
  warn: 'bg-pending text-pending-foreground',
  danger: 'bg-fail text-fail-foreground',
  pending: 'bg-pending text-pending-foreground',
  neutral: 'bg-secondary text-muted-foreground',
};
